/* eslint-disable no-console */
// Petit logger : silencieux en production, console.debug en développement uniquement.
const isDev = typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production";

export const logger = {
  debug: (...args) => { if (isDev) console.debug(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
};
